import { Grid, PaperGroupItem } from '@focaldata/cin-ui-components'
import React from 'react'
import { CardBackgroundContainer } from '../../modules/Questionnaire/CardBackground'

interface Props {
  questionCardHeader: JSX.Element
  switches: JSX.Element
  sliderInputs: JSX.Element
  defaultOptions: JSX.Element | null
  sliderLabels?: JSX.Element | null
  showLabels?: boolean
  entryId: string
}

const SliderQuestionLayout: React.FC<Props> = (props: Props) => {
  const {
    questionCardHeader,
    switches,
    sliderInputs,
    sliderLabels,
    showLabels,
    defaultOptions,
    entryId
  } = props

  return (
    <Grid container>
      <CardBackgroundContainer entryId={entryId}>
        <PaperGroupItem>{questionCardHeader}</PaperGroupItem>
        <PaperGroupItem paddingTopBottom={2}>{switches}</PaperGroupItem>
        <PaperGroupItem paddingTopBottom={2}>{sliderInputs}</PaperGroupItem>
        {showLabels && (
          <PaperGroupItem paddingTopBottom={2}>{sliderLabels}</PaperGroupItem>
        )}
        {defaultOptions && (
          <PaperGroupItem paddingTopBottom={2}>{defaultOptions}</PaperGroupItem>
        )}
      </CardBackgroundContainer>
    </Grid>
  )
}

export default SliderQuestionLayout
